class TileSlideshow {
	constructor(el) {
		if (!el) return;

		this.el = el;

		const autoplay = el.dataset.autoplay === 'false';
		const interval = parseInt(el.dataset.interval) || 5000;
		const speed = parseInt(el.dataset.speed) || 800;
		const rewind = el.dataset.rewind === 'false';
		const pauseOnHover = el.dataset.pauseOnHover === 'false';
		const pauseOnFocus = el.dataset.pauseOnFocus === 'false';

		this.splide = new Splide(el, {
			rewind,
			autoplay,
			interval,
			speed,
			pauseOnHover,
			pauseOnFocus,
			perPage: 3,
			gap: 'var(--spacing-4x)',
			arrows: true,
			pagination: false,
			breakpoints: {
				767: { perPage: 1 }
			}
		}).mount();
	}
}
